<template>
  <div class="mx-auto justify-center align-center" style="padding-inline: 12px; margin-block: 40px">
    <button
      class="btn-block bg-white text-black btn mx-auto"
      style="border: 1px solid black"
      @click="getMicrosoftToken"
    >
      <i class="fa fa-windows mr-3" aria-hidden="true"></i>
      Entrar com Microsoft
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { PublicClientApplication } from '@azure/msal-browser'
import { loginFB } from '../services/ServFB.js'

const lFB = new loginFB()

export default {
  name: 'MicrosoftSSO',
  methods: {
    async getMicrosoftToken() {
      const msalInstance = new PublicClientApplication(this.msalConfig)
      await msalInstance
        .loginPopup({
          scopes: ['User.Read'],
        })
        .then(res => {
          const token = res.accessToken
          const systemId = 100
          const subDomainLogin = this.subdomain
          const ownerID = this.config.ownerId
          this.loginWithMicrosoftToken(token, systemId, subDomainLogin, ownerID)
        })
    },
    async loginWithMicrosoftToken(token, systemID, subdomain, ownerID) {
      const payload = {
        IdToken: token,
        systemId: systemID,
        ownerId: ownerID,
        subDomainLogin: subdomain,
      }
      await lFB
        .externalSSO(payload)
        .then(res => {
          this.$emit('user-is-signed', res)
        })
        .catch(err => {
          this.$bvToast.toast(err, {
            title: `Erro`,
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
  computed: {
    ...mapState(['config', 'subdomain']),
    msalConfig() {
      if (this.config) {
        return {
          auth: {
            clientId: this.config.externalSSO[0].auth.clientId,
            authority: this.config.externalSSO[0].auth.authority,
            redirectUri: this.config.externalSSO[0].auth.redirectUri,
          },
          cache: {
            cacheLocation: 'localStorage',
          },
        }
      }
      return null
    },
  },
  async created() {
    this.$msalInstance = new PublicClientApplication(this.msalConfig)
  },
}
</script>
